import { css, cx } from "@emotion/css";
import MUISwipeableDrawer, {
	type SwipeableDrawerProps as MuiSwipeableDrawerProps,
} from "@mui/material/SwipeableDrawer";
import type { ReactNode } from "react";
import { use100vh } from "react-div-100vh";

import isMobile from "../../../helpers/isMobile";

interface SwipeableDrawerProps {
	open: boolean;
	onOpen?: MuiSwipeableDrawerProps["onOpen"];
	onClose: () => void;
	children: ReactNode;
	// MUI 9: przekazywane jako slotProps.swipeArea
	SwipeAreaProps?: object;
}

export const SwipeableDrawer = ({
	open,
	onOpen,
	onClose,
	children,
	SwipeAreaProps,
}: SwipeableDrawerProps) => {
	const height = use100vh();

	return (
		<MUISwipeableDrawer
			className={cx(
				"swipeable-drawer",
				css`
          & .MuiDrawer-paper {
            padding-top: 16px;
            max-height: ${(height ?? 0) - 80}px;
          }
        `,
			)}
			anchor="bottom"
			open={open}
			onClose={onClose}
			onOpen={onOpen ?? (() => {})}
			disableSwipeToOpen
			slotProps={{ swipeArea: SwipeAreaProps }}
			hysteresis={onClose ? 0.51 : 1}
		>
			<div className="puller" />
			<div className="drawer-box">{children}</div>
		</MUISwipeableDrawer>
	);
};

interface SwipeableContentProps {
	children: ReactNode;
	topMargin?: number;
	isOpen: boolean;
	onClose: () => void;
	onOpen?: MuiSwipeableDrawerProps["onOpen"];
}

export const SwipeableContent = ({
	children,
	topMargin,
	...props
}: SwipeableContentProps) => {
	if (!isMobile()) {
		return children;
	}

	return (
		<SwipeableDrawer
			open={props.isOpen}
			onClose={props.onClose}
			SwipeAreaProps={{
				defaultMuiPrevented: true,
			}}
		>
			{children}
		</SwipeableDrawer>
	);
};
